import { useState } from "react";
import { Container, Nav } from "react-bootstrap";
import CurrentAuditsBlock from "./CurrentAuditsBlock";
import PlannedAuditsBlock from "./PlannedAuditsBlock";
import PassedAuditsBlock from "./PassedAuditsBlock";
import ArchiveAuditsBlock from "../ArchiveAudits/ArchiveAuditsBlock";
import { getUserData } from "../../reuse/getUserRole";
import { CalendarPageBlock } from "../CalendarPage/CalendarPageBlock";

const Audits_block = () => {
    const [activeComponent, setActiveComponent] = useState('current');
    const renderComponent = () => {
        switch(activeComponent) {
            case 'current':
                return <CurrentAuditsBlock/>;
            case 'planning':
                return <PlannedAuditsBlock/>;
            case 'passed':
                return <PassedAuditsBlock/>;
            case 'archive':
                return <ArchiveAuditsBlock/>;
            case 'calendar':
                return <CalendarPageBlock/>;
            default:
                return <CurrentAuditsBlock/>;
        }
    };

    return(
        <>
            <div>
                <Nav variant="pills" defaultActiveKey={"current"}>
                    <Nav.Item>
                        <Nav.Link eventKey={"current"} onClick={() => setActiveComponent('current')}>
                            Текущие
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey={"planning"} onClick={() => setActiveComponent('planning')}>
                            Запланированные
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey={"passed"} onClick={() => setActiveComponent('passed')}>
                            Прошедшие
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item>
                        <Nav.Link eventKey={"calendar"} onClick={() => setActiveComponent('calendar')}>
                            Календарь
                        </Nav.Link>
                    </Nav.Item>
                    {!(getUserData() in ["Admin","Admin-RO","Moderator"]) ? 
                    <Nav.Item>
                        <Nav.Link eventKey={"archive"} onClick={() => setActiveComponent('archive')}>
                            Архивные
                        </Nav.Link>
                    </Nav.Item> : null
                    }
                </Nav>
            </div>
            <div>
            <div className="mt-3">
                {renderComponent()}
            </div>
            </div>
        </>
    )
}

export default Audits_block;